import { AddLiabilityScanData } from '../models/add-liability-scan-data.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { bbanValidator } from 'src/app/shared/validators/bban.validator';
import { nipValidator } from '../../shared/validators/nip.validator';

export class AddLiabilityScanForm extends FormGroup {
  private min: number;
  private max: number;

  constructor(
    liabilityMinAmount: number,
    liabilityMaxAmount: number,
    amount: number,
    bban: string,
    title: string,
    paymentDue = new Date(),
    billerId: string,
    billerName: string,
    nip: string,
  ) {
    super({
      customerBillerId: new FormControl({ value: '', disabled: true }, [Validators.required]),
      billerId: new FormControl({ value: billerId, disabled: true }, [Validators.required]),
      billerName: new FormControl({ value: billerName, disabled: true }, [Validators.required]),
      amount: new FormControl({ value: amount, disabled: true }, [
        Validators.required,
        Validators.min(liabilityMinAmount),
        Validators.max(liabilityMaxAmount),
      ]),
      bban: new FormControl({ value: bban, disabled: true }, [bbanValidator, Validators.required]),
      title: new FormControl(title, [Validators.required, Validators.maxLength(40)]),
      paymentDue: new FormControl(paymentDue, [Validators.required]),
      nip: new FormControl(nip, [nipValidator(true)]),
    });
    this.min = liabilityMinAmount;
    this.max = liabilityMaxAmount;
  }

  get customerBillerId(): FormControl {
    return this.get('customerBillerId') as FormControl;
  }

  get biller(): FormControl {
    return this.get('billerName') as FormControl;
  }

  get billerId(): FormControl {
    return this.get('billerId') as FormControl;
  }

  get amount(): FormControl {
    return this.get('amount') as FormControl;
  }

  get bban(): FormControl {
    return this.get('bban') as FormControl;
  }

  get title(): FormControl {
    return this.get('title') as FormControl;
  }

  get paymentDue(): FormControl {
    return this.get('paymentDue') as FormControl;
  }

  get nip(): FormControl {
    return this.get('nip') as FormControl;
  }

  public hasAmountInLimit() {
    return this.amount.value >= this.min && this.amount.value <= this.max;
  }

  public getFinalData(): AddLiabilityScanData {
    return {
      customerBillerId: this.customerBillerId.value,
      amount: this.amount.value,
      amountToPay: this.amount.value,
      bban: this.bban.value,
      title: this.title.value,
      paymentDue: this.paymentDue.value,
      nip: this.nip.value,
    };
  }
}
